import "../../../../src/pages/design/design-guidelines-styles.css";
import { BrandColorRamp, ColorRamp, ColorRampGrid } from "../../../../src/components/ColorSwatch";
import * as React from 'react';
export default {
  BrandColorRamp,
  ColorRamp,
  ColorRampGrid,
  React
};